<template>
  <div>
    <h1>{{$t('global.menu.settings')}}</h1>
    <div class="text-right">
      <a :href="exportUrl" target="_blank" :download="$t('user.dataExport.fileName')">{{$t('user.dataExport.link')}}</a>
    </div>
    <UserForm v-if="item" :handle-submit="update" :values="item" :errors="violations"
              :initialValues="retrieved"></UserForm>
  </div>
</template>

<script>
import UserForm from './Form.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        UserForm
    },
    data: function() {
        return {
            item: {}
        };
    },
    computed: mapGetters({
        loading: 'loading/loading/loading',
        violations: 'violation/list/violations',
        logged: 'user/auth/logged',
        created: 'user/create/created',
        retrieved: 'user/update/retrieved',
        updated: 'user/update/updated',
        exportUrl: 'user/update/exportUrl'
    }),
    methods: {
        update(values) {
            this.$store.dispatch('user/update/update', {item: this.retrieved, values: values}).then((result) => {
                this.$store.dispatch('user/auth/getCurrent').then(() => {
                    this.$notify.success(this.$t('user.alert.updated'));
                });
            });
        },
        reset() {
            this.$store.dispatch('user/update/reset');
        }
    },
    created() {
        this.$store.dispatch('user/update/retrieve');
        this.$store.dispatch('user/update/retrieveExport');
    },
    beforeDestroy() {
        this.reset();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Update.vue